// // src/components/AccountPage.jsx

// import { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import BackButton from "./BackButton";
// import { getAuthToken, signOut, getUserProfile } from "../utils/auth";
// import promo1 from "../images/promo1.jpg";
// import promo2 from "../images/promo2.jpg";

// const ORDERS_API_URL = "https://us-central1-retail-jkommerce-poc.cloudfunctions.net/customer_orders_v1";

// export default function AccountPage() {
//   const navigate = useNavigate();
//   const token = getAuthToken();
//   const userProfile = getUserProfile();

//   const [orders, setOrders] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // Mock user data fallback
//   const user = {
//     username: userProfile?.customer_name || "Guest",
//     points: 200,
//     pointsToStatus: 800,
//     memberID: userProfile?.customer_id || "N/A",
//   };

//   // Fetch orders on mount
// useEffect(() => {
//   const fetchOrders = async () => {
//     if (!userProfile?.customer_id) {
//       setError("Customer ID not found.");
//       setLoading(false);
//       return;
//     }

//     try {
//       const response = await fetch(ORDERS_API_URL.trim(), {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ customer_id: userProfile.customer_id }),
//       });

//       if (!response.ok) {
//         throw new Error(`Failed to load orders: ${response.status}`);
//       }

//       const data = await response.json();
//       const rawOrders = Array.isArray(data) ? data : [];

//       // ✅ Transform API response to match UI expectations
//       const mappedOrders = rawOrders.map((order) => {
//         const quantity = order.quantity || 1;
//         const totalRevenue = parseFloat(order.purchase_revenue) || 0;
//         const unitPrice = quantity > 0 ? totalRevenue / quantity : 0;

//         // Parse DD-MM-YYYY → convert to YYYY-MM-DD for Date()
//         const [day, month, year] = order.event_time.split('-');
//         const isoDate = `${year}-${month}-${day}`;

//         return {
//           transaction_id: order.id || order.article_id,
//           t_dat: isoDate, // ← UI expects this
//           enhanced_prod_name: order.enhanced_prod_name,
//           prod_name: order.prod_name,
//           price: unitPrice, // ← derived from purchase_revenue
//           quantity: quantity,
//           article_id: order.article_id,
//           // Keep original for debugging if needed
//           raw: order,
//         };
//       });

//       setOrders(mappedOrders);
//     } catch (err) {
//       console.error("Order fetch error:", err);
//       setError(err.message || "Unable to load order history.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   fetchOrders();
// }, [userProfile?.customer_id]);

//   const handleSignOut = () => {
//     if (window.confirm("Are you sure you want to sign out?")) {
//       signOut();
//       alert("Signed out successfully.");
//       navigate("/");
//        window.location.reload();
     
//     }
//   };

//   if (!token) {
//     navigate("/sign-in");
//     return null;
//   }

//   // Format date for display
//   const formatDate = (dateStr) => {
//     const date = new Date(dateStr);
//     return date.toLocaleDateString("en-US", {
//       year: "numeric",
//       month: "short",
//       day: "numeric",
//     });
//   };

//   return (
//     <div className="max-w-screen-xl mx-auto px-4 py-10">
//       <BackButton />

//       <div className="flex flex-col lg:flex-row gap-8">
//         {/* Left Sidebar */}
//         <div className="w-full lg:w-80 space-y-6">
//           <div>
//             <p className="text-sm text-gray-700">
//               Welcome, <span className="font-medium">{user.username}</span>
//             </p>
            
//             <div className="mt-2 text-xs text-gray-500">
            
//             </div>
//             <p className="text-xs text-gray-500 mt-2">
//               MEMBERSHIP ID: {user.memberID}
//             </p>
//           </div>

//           <nav className="space-y-3">
          
//             <button
//               onClick={() => navigate("/orders")}
//               className="block w-full text-left font-medium text-gray-900 hover:text-[#3a3172] transition-colors"
//             >
//               ORDERS
//             </button>
          
//             <button
//               onClick={() => navigate("/settings")}
//               className="block w-full text-left font-medium text-gray-900 hover:text-[#3a3172] transition-colors"
//             >
//               ACCOUNT SETTINGS
//             </button>
//           </nav>

//           <button
//             onClick={handleSignOut}
//             className="block w-full text-left text-sm text-[#3a3172] hover:underline transition-colors"
//           >
//             SIGN OUT
//           </button>
//         </div>

//         {/* Right Content */}
//         <div className="flex-1">
          

//           {/* Order History Section */}
//           <div className="mb-10">
//             <h2 className="text-2xl font-bold text-gray-900 mb-4">Order History</h2>

//             {loading ? (
//               <div className="flex justify-center items-center h-32">
//                 <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-[#3a3172]"></div>
//               </div>
//             ) : error ? (
//               <div className="bg-[#f0f9ff] border border-[#cdeefc] rounded-lg p-4">
//                 <p className="text-[#2c2452]">{error}</p>
//               </div>
//             ) : orders.length === 0 ? (
//               <p className="text-gray-600">No orders found.</p>
//             ) : (
//               <div className="overflow-x-auto">
//                 <table className="min-w-full bg-white border border-gray-200 rounded-lg">
//                   <thead className="bg-gray-50">
//                     <tr>
//                       <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date</th>
//                       <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Product</th>
//                       <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Price</th>
//                       <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Qty</th>
//                       <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Total</th>
//                     </tr>
//                   </thead>
//                   <tbody className="divide-y divide-gray-200">
//                     {orders.map((order) => {
//                       const price = parseFloat(order.price) || 0;
//                       const total = price * (order.quantity || 1);
//                       return (
//                         <tr key={order.transaction_id} className="hover:bg-gray-50">
//                           <td className="px-4 py-3 text-sm text-gray-700 whitespace-nowrap">
//                             {formatDate(order.t_dat)}
//                           </td>
//                           <td className="px-4 py-3 text-sm text-gray-900">
//                             {order.enhanced_prod_name || order.prod_name}
//                           </td>
//                           <td className="px-4 py-3 text-sm text-gray-700">
//                             ${price.toFixed(2)}
//                           </td>
//                           <td className="px-4 py-3 text-sm text-gray-700">
//                             {order.quantity}
//                           </td>
//                           <td className="px-4 py-3 text-sm font-medium text-gray-900">
//                             ${total.toFixed(2)}
//                           </td>
//                         </tr>
//                       );
//                     })}
//                   </tbody>
//                 </table>
//               </div>
//             )}
//           </div>

//           {/* Promotions */}
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//             <div className="bg-white border rounded-lg p-4 shadow-sm">
//               <img
//                 src={promo1}
//                 alt="10% Off Your Purchase"
//                 className="w-full h-60 object-cover rounded-md"
//               />
//               <div className="mt-3">
//                 <p className="text-sm font-medium text-gray-900">
//                   10% OFF YOUR TOTAL PURCHASE | WELCOME...
//                 </p>
//                 <p className="text-xs text-gray-500 mt-1">VALID UNTIL: 17/09/2025</p>
//               </div>
//             </div>

//             <div className="bg-white border rounded-lg p-4 shadow-sm">
//               <div className="flex items-center justify-center h-60 bg-red-50 rounded-md">
//                 <img
//                   src={promo2}
//                   alt="Tim Hortons"
//                   className="h-40 w-auto object-contain"
//                 />
//               </div>
//               <div className="mt-3">
//                 <p className="text-sm font-medium text-gray-900">
//                   BUY 1 GET 1 FREE AT TIM HORTONS
//                 </p>
//                 <p className="text-xs text-gray-500 mt-1">VALID UNTIL: 30/09/2025</p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }


// src/components/AccountPage.jsx
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import BackButton from "./BackButton";
import { getAuthToken, getUserProfile } from "../utils/auth";
import { useSignOut } from "../hooks/useSignOut";
import promo1 from "../images/promo1.jpg";
import promo2 from "../images/promo2.jpg";
import { fetchUserProfile, updateUserProfile } from "../api/userProfileApi";
import { CUSTOMER_ORDERS_URL } from "../config/apiConfig";

const ORDERS_API_URL = CUSTOMER_ORDERS_URL;

export default function AccountPage() {
  const navigate = useNavigate();
  const token = getAuthToken();
  const userProfile = getUserProfile();
  const customerId = userProfile?.customer_id;

  // UI State
  const [activeTab, setActiveTab] = useState("orders"); // 'orders' | 'settings'
  const [orders, setOrders] = useState([]);
  const [loadingOrders, setLoadingOrders] = useState(true);
  const [errorOrders, setErrorOrders] = useState(null);

  // Settings state
  const [settingsData, setSettingsData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    age: "",
    address: "",
    address_tag: "",
    payment_detail: "",
  });
  const [loadingProfile, setLoadingProfile] = useState(true);
  const [saving, setSaving] = useState(false);
  const [profileError, setProfileError] = useState(null);
  const [profileSuccess, setProfileSuccess] = useState(false);
  
  // Sign out. The confirmation modal is this page's; the sign-out itself is
  // the shared hook, the same one the top bar's account menu uses. It ends
  // in a full load of "/", so the modal stays on "Signing out..." until then.
  const [showSignOutModal, setShowSignOutModal] = useState(false);
  const { signingOut: isSigningOut, signOut: handleConfirmSignOut } = useSignOut();

  // Mock user data fallback
  const user = {
    username: userProfile?.customer_name || "Guest",
    points: 200,
    pointsToStatus: 800,
    memberID: customerId || "N/A",
  };

  // 🔁 Fetch orders
  useEffect(() => {
    if (activeTab !== "orders" || !customerId) return;

    const fetchOrders = async () => {
      setLoadingOrders(true);
      setErrorOrders(null);
      try {
        const response = await fetch(ORDERS_API_URL, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ customer_id: customerId }),
        });

        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const data = await response.json();
        const rawOrders = Array.isArray(data) ? data : [];

        const mappedOrders = rawOrders.map((order) => {
          const quantity = order.quantity || 1;
          const totalRevenue = parseFloat(order.purchase_revenue) || 0;
          const unitPrice = quantity > 0 ? totalRevenue / quantity : 0;
          const [day, month, year] = order.event_time?.split("-") || [];
          const isoDate = year && month && day ? `${year}-${month}-${day}` : "";
          const product_price=order.product_price;

          return {
            transaction_id: order.id || order.article_id,
            t_dat: isoDate,
            enhanced_prod_name: order.enhanced_prod_name,
            prod_name: order.prod_name,
            price: unitPrice,
            quantity: quantity,
            article_id: order.article_id,
            prod_price:product_price
          };
        });

        setOrders(mappedOrders);
      } catch (err) {
        console.error("Order fetch error:", err);
        setErrorOrders(err.message || "Failed to load orders.");
      } finally {
        setLoadingOrders(false);
      }
    };

    fetchOrders();
  }, [activeTab, customerId]);

  // 🔁 Fetch profile when switching to settings
  useEffect(() => {
    if (activeTab !== "settings" || !customerId) return;

    const loadProfile = async () => {
      setLoadingProfile(true);
      setProfileError(null);
      try {
        const profile = await fetchUserProfile(customerId);
        setSettingsData({
          first_name: profile.first_name || "",
          last_name: profile.last_name || "",
          email: profile.email || "",
          age: profile.age || "",
          address: profile.address || "",
          address_tag: profile.address_tag || "",
          payment_detail: profile.payment_detail || "",
        });
      } catch (err) {
        setProfileError(err.message || "Failed to load profile.");
      } finally {
        setLoadingProfile(false);
      }
    };

    loadProfile();
  }, [activeTab, customerId]);

  const handleSignOut = () => {
    // Show confirmation modal
    setShowSignOutModal(true);
  };

  const handleCancelSignOut = () => {
    setShowSignOutModal(false);
  };

  const handleSettingsChange = (e) => {
    const { name, value } = e.target;
    setSettingsData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSaveSettings = async (e) => {
    e.preventDefault();
    setSaving(true);
    setProfileError(null);
    setProfileSuccess(false);

    try {
      const payload = {
        customer_id: customerId,
        first_name: settingsData.first_name,
        last_name: settingsData.last_name,
        age: settingsData.age ? Number(settingsData.age) : undefined,
        address: settingsData.address,
        address_tag: settingsData.address_tag,
        payment_detail: settingsData.payment_detail,
      };

      await updateUserProfile(payload);
      setProfileSuccess(true);
      // Optional: refresh auth profile cookie if needed
    } catch (err) {
      setProfileError(err.message || "Failed to update profile.");
    } finally {
      setSaving(false);
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "—";
    const date = new Date(dateStr);
    return isNaN(date.getTime())
      ? "Invalid Date"
      : date.toLocaleDateString("en-US", {
          year: "numeric",
          month: "short",
          day: "numeric",
        });
  };

  // 🔐 Auth guard
  if (!token) {
    navigate("/sign-in");
    return null;
  }

  return (
    <div className="max-w-screen-xl mx-auto px-4 py-10">
      <BackButton />

      <div className="flex flex-col lg:flex-row gap-8">
        {/* Left Sidebar */}
        <div className="w-full lg:w-80 space-y-6">
          <div>
            <p className="text-sm text-gray-700">
              Welcome, <span className="font-medium">{user.username}</span>
            </p>
            <p className="text-xs text-gray-500 mt-2">MEMBERSHIP ID: {user.memberID}</p>
          </div>

          <nav className="space-y-3">
            <button
              onClick={() => setActiveTab("orders")}
              className={`block w-full text-left font-medium transition-colors ${
                activeTab === "orders"
                  ? "text-[#3a3172] border-l-4 border-[#3a3172] pl-2"
                  : "text-gray-900 hover:text-[#3a3172]"
              }`}
            >
              ORDERS
            </button>

            <button
              onClick={() => setActiveTab("settings")}
              className={`block w-full text-left font-medium transition-colors ${
                activeTab === "settings"
                  ? "text-[#3a3172] border-l-4 border-[#3a3172] pl-2"
                  : "text-gray-900 hover:text-[#3a3172]"
              }`}
            >
              ACCOUNT SETTINGS
            </button>
          </nav>

          <button
            onClick={handleSignOut}
            className="block w-full text-left text-sm text-[#3a3172] hover:underline transition-colors"
          >
            SIGN OUT
          </button>
        </div>

        {/* Sign Out Confirmation Modal */}
        {showSignOutModal && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
            <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4 shadow-xl">
              <h2 className="text-xl font-semibold mb-4">Sign Out</h2>
              <p className="text-gray-700 mb-6">Are you sure you want to sign out?</p>
              
              {isSigningOut ? (
                <div className="flex flex-col items-center gap-4">
                  <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#3a3172]"></div>
                  <p className="text-gray-700 font-medium">Signing out...</p>
                </div>
              ) : (
                <div className="flex gap-3 justify-end">
                  <button
                    onClick={handleCancelSignOut}
                    className="px-4 py-2 text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 transition-colors"
                    disabled={isSigningOut}
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleConfirmSignOut}
                    className="px-4 py-2 text-[#1f1a45] bg-[#bfeeff] rounded-md hover:bg-[#a6e4fb] transition-colors"
                    disabled={isSigningOut}
                  >
                    Sign Out
                  </button>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Right Content */}
        <div className="flex-1">
          {activeTab === "orders" && (
            <div className="mb-10">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Order History</h2>

              {loadingOrders ? (
                <div className="flex justify-center items-center h-32">
                  <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-[#3a3172]"></div>
                </div>
              ) : errorOrders ? (
                <div className="bg-[#f0f9ff] border border-[#cdeefc] rounded-lg p-4">
                  <p className="text-[#2c2452]">{errorOrders}</p>
                </div>
              ) : orders.length === 0 ? (
                <p className="text-gray-600">No orders found.</p>
              ) : (
                <div className="overflow-x-auto">
                  <table className="min-w-full bg-white border border-gray-200 rounded-lg">
                    <thead className="bg-gray-50">
                      <tr>
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date</th>
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Product</th>
                           <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Product_Price</th>
                      
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Qty</th>
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Total</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200">
                      {orders.map((order) => {
                        const price = parseFloat(order.price) || 0;
                        const total = price * (order.quantity || 1);
                        return (
                          <tr key={order.transaction_id} className="hover:bg-gray-50">
                            <td className="px-4 py-3 text-sm text-gray-700 whitespace-nowrap">
                              {formatDate(order.t_dat)}
                            </td>
                            <td className="px-4 py-3 text-sm text-gray-900">
                              {order.enhanced_prod_name || order.prod_name}
                            </td>
                             <td className="px-4 py-3 text-sm text-gray-900">
                               ${order.prod_price}
                            </td>
                         
                            <td className="px-4 py-3 text-sm text-gray-700">
                              {order.quantity}
                            </td>
                            <td className="px-4 py-3 text-sm font-medium text-gray-900">
                              ${total.toFixed(2)}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          )}

          {activeTab === "settings" && (
            <div className="mb-10">
              <h2 className="text-2xl font-bold text-gray-900 mb-6">Account Settings</h2>

              {profileError && <div className="mb-4 p-3 bg-red-100 text-red-700 rounded">{profileError}</div>}
              {profileSuccess && <div className="mb-4 p-3 bg-green-100 text-green-700 rounded">Profile updated successfully!</div>}

              {loadingProfile ? (
                <div className="text-center py-6">
                  <p className="text-gray-600">Loading profile...</p>
                </div>
              ) : (
                <form onSubmit={handleSaveSettings} className="space-y-5 max-w-2xl">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">First Name</label>
                    <input
                      type="text"
                      name="first_name"
                      value={settingsData.first_name}
                      onChange={handleSettingsChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md"
                      required
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Last Name</label>
                    <input
                      type="text"
                      name="last_name"
                      value={settingsData.last_name}
                      onChange={handleSettingsChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md"
                      required
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                    <input
                      type="email"
                      name="email"
                      value={settingsData.email}
                      readOnly
                      disabled
                      className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-100"
                    />
                    <p className="text-xs text-gray-500 mt-1">Email cannot be changed.</p>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Age</label>
                    <input
                      type="number"
                      name="age"
                      value={settingsData.age}
                      onChange={handleSettingsChange}
                      min="0"
                      className="w-full px-3 py-2 border border-gray-300 rounded-md"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Address</label>
                    <input
                      type="text"
                      name="address"
                      value={settingsData.address}
                      onChange={handleSettingsChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Address Type</label>
                    <input
                      type="text"
                      name="address_tag"
                      value={settingsData.address_tag}
                      onChange={handleSettingsChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Payment Method</label>
                    <input
                      type="text"
                      name="payment_detail"
                      value={settingsData.payment_detail}
                      onChange={handleSettingsChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md"
                    />
                  </div>

                  <div className="pt-2">
                    <button
                      type="submit"
                      disabled={saving}
                      className="px-6 py-2 bg-[#bfeeff] text-[#1f1a45] rounded-md hover:bg-[#a6e4fb] disabled:opacity-70"
                    >
                      {saving ? "Saving..." : "Save Changes"}
                    </button>
                  </div>
                </form>
              )}
            </div>
          )}

          {/* Promotions (shown under both tabs) */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-white border rounded-lg p-4 shadow-sm">
              <img
                src={promo1}
                alt="10% Off Your Purchase"
                className="w-full h-60 object-cover rounded-md"
              />
              <div className="mt-3">
                <p className="text-sm font-medium text-gray-900">
                  10% OFF YOUR TOTAL PURCHASE | WELCOME...
                </p>
                <p className="text-xs text-gray-500 mt-1">VALID UNTIL: 17/09/2025</p>
              </div>
            </div>

            <div className="bg-white border rounded-lg p-4 shadow-sm">
              <div className="flex items-center justify-center h-60 bg-red-50 rounded-md">
                <img
                  src={promo2}
                  alt="Tim Hortons"
                  className="h-40 w-auto object-contain"
                />
              </div>
              <div className="mt-3">
                <p className="text-sm font-medium text-gray-900">
                  BUY 1 GET 1 FREE AT TIM HORTONS
                </p>
                <p className="text-xs text-gray-500 mt-1">VALID UNTIL: 30/09/2025</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}